import script from "./PlatformTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformTabs.vue?vue&type=script&setup=true&lang=js"

import "./PlatformTabs.vue?vue&type=style&index=0&id=951aeae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-951aeae4"]])

export default __exports__